import React from 'react';
import '../styles/App.css';

const SectionICCOnline = () => (
  <section className="crt-section">
    <h2 className="crt-title">Christ Refuge Pour Tous</h2>
    <p className="crt-desc">
      Christ Refuge Pour Tous (CRPT) est une famille de foi dynamique et accueillante, ouverte à tous ceux qui cherchent à grandir spirituellement et à vivre l’amour de Dieu au quotidien. Rejoins-nous pour découvrir une communauté engagée, des enseignements inspirants et des temps forts dans la présence de Dieu.
    </p>
    <a className="crt-btn" href="/gj-crpt">
      Découvrir CRPT
    </a>
  </section>
);

export default SectionICCOnline;
